import React from "react";
import parameters from "../../../config/parameters";
import SearchDriveApi from "../../api/SearchDriveApi";
import { getFileByFileId } from "../../api/GoogleDriveApi";
import { updateNavigationList, updateNavigationListSearch } from "../../../actions/widgetAction";
import { ReactComponent as Navigate } from "../../../assets/navigate.svg";
import SVG from "../../components/svg";
import Wix from "Wix";
import { connect } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import "./Menu.scss";

class Menu extends SearchDriveApi {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.searchFile = this.searchFile.bind(this);
    this.showSearchMobileClicked = this.showSearchMobileClicked.bind(this);
    this.searchMobileClicked = this.searchMobileClicked.bind(this);
    this.closeSearchMobile = this.closeSearchMobile.bind(this);
    this.renderNavigate = this.renderNavigate.bind(this);
    this.getNavigate = this.getNavigate.bind(this);
    this.showMenuNavigate = this.showMenuNavigate.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.buildTreeFolders = this.buildTreeFolders.bind(this);
    this.state = {
      items: this.props.itemList,
      resultLength: this.props.resultLength ? this.props.resultLength : 0,
      showSearchMobile: false,
      searchEvent: this.props.searchEvent ? this.props.searchEvent : false,
      SearchSignleFile: this.props.SearchSignleFile
        ? this.props.SearchSignleFile
        : false,
      showMenuIcons: true,
      showMenuNavigate: false,
      displaySearchBar: true,
      displaySortIcon: true,
      layoutFolder: this.props.layoutFolder,
      searchInput: this.props.searchInput
    };
  }

  updateState(data) {
    if (data && data.booleans) {
      if (
        (data.booleans.displaySearchBar === false ||
          data.booleans.displaySearchBar === true) &&
        data.booleans.displaySearchBar !== this.state.displaySearchBar
      )
        this.setState({ displaySearchBar: data.booleans.displaySearchBar });
      // if (
      //   (data.booleans.displaySortIcon === false || data.booleans.displaySortIcon === true) &&
      //    data.booleans.displaySortIcon !== this.state.displaySortIcon
      // )
      //   this.setState({ displaySortIcon: data.booleans.displaySortIcon });
    }
    if (data && data.numbers) {
      if (
        (data.numbers.select_layout === 1 ||
          data.numbers.select_layout === 2) &&
          data.numbers.select_layout !== this.state.layoutFolder
        ) {
          this.searchInput.value = '';
          this.setState({ layoutFolder: data.numbers.select_layout, searchInput:'' });
      }
    }
  }
  componentWillReceiveProps(newProps) {
    if (newProps.emptyFolder) {
      //this.searchInput.value = '';
      this.setState({ SearchSignleFile: newProps.SearchSignleFile });
    }
    else {
      this.setState({ SearchSignleFile: newProps.SearchSignleFile  });
    }
  }
  componentWillMount() {
    // add event listener for clicks
    document.addEventListener("click", this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    // make sure you remove the listener when the component is destroyed
    document.removeEventListener("click", this.handleOutsideClick, false);
    this._isMounted = false;
  }
  componentDidMount() {
    Wix.Styles.getStyleParams(style => {
      this.updateState(style);
    });

    Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, style => {
      this.updateState(style);
    });
    this._isMounted = true;
    //this.deviceType = Wix.Utils.getDeviceType();
    this.setState({
      deviceType: Wix.Utils.getDeviceType()
    });
    this.buildTreeFolders(this.props.id,this.props.resourceKey, { id: "first" },()=> {console.log('After Build Callback')});
  }
  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.node.contains(e.target)) {
      return;
    }
    this.showMenuNavigate();
  }
  /**
   * Show navigate menu in mobile .
   * @param {boolean} event if show menu
   */
  showMenuNavigate(event) {
    if (!this.state.showMenuNavigate) {
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    // event.preventDefault();
    const currentState = this.state.showMenuNavigate;
    this.setState({
      showMenuNavigate: !currentState
    });
  }
  /**
   * Search file by value of text input.
   */
  searchFile() {
    if (this.searchInput.value !== "") {
      this.setState({ items: [], searchInput: this.searchInput.value});
      this.props.searchEvent(true);
      this.searchFiles(this.props.id, this.searchInput.value, result => {
        this.props.addFiles(result);
        this.setState({ resultLength: result.length });
        if (result.length && result[0].parents[0]) {
            getFileByFileId(result[0].parents[0].id,result[0].parents[0].resourceKey, item => {
            this.setState({
              driveSelected: item,
              showMenuIcons: true,
              SearchSignleFile:false,
              showSearchMobile:false
            });
            this.props.searchEvent(false);
          },false);
        } else {
          this.setState({showMenuIcons: true ,SearchSignleFile:false,showSearchMobile:false});
          this.props.searchEvent(false);
        }
      });
      this.setState({showSearchMobile:false});
    }
  }
  searchMobileClicked() {
    this.searchFile();
  }
  showSearchMobileClicked() {
    this.searchInput.value = '';
    this.setState({ showSearchMobile: true, showMenuIcons: false, searchInput:'' });
  }
  closeSearchMobile() {
    this.setState({ showSearchMobile: false, showMenuIcons: true });
  }
  /**
   * render navigate of folder
   * @param {Object} folder the folder to navigate
   * @param {String} folderTitle title of folder
   * @param {boolean} enabledClick if enable click on navigate
   */
  renderNavigate(folder, folderTitle, enabledClick, isLastNavigate) {

    return enabledClick ? (
      <div className="get-navigate"
      onClick={() => this.props.openFolder(folder)}
      >
        <div
          className="navigateClicked overflow-name"
        >
          {folderTitle}
          {<span className={ isLastNavigate? "lastNavigateArrow" : "navigateArrow"}>
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
          <g fill="none" fillRule="evenodd" stroke="#000">
              <path d="M1.229 4L5 .229 8.771 4M5 .408v10.666"/>
          </g>
          </svg>
          </span>}
        </div>
      </div>
    ) : (
        <div className="navigate overflow-name">{folderTitle}</div>
        );
  }
  /**
   * Create navigate from folder selected
   * @param {Object} folder the selected folder
   * @param {boolean} enabledClick if enable click on navigate
   */
  getNavigate(folder, enabledClick, isLastNavigate) {
    if (
      (this.state.driveSelected &&
        this.state.driveSelected.mimeType !== parameters["TYPE_FOLDER"]) ||
      !this.props.navigateList ||
      !this.props.navigateList[folder.id]
    ) {
      return null;
    } else if (this.props.navigateList[folder.id].parent.id) {
      let title = this.props.navigateList[folder.id].title;
      return (
        <div className="navigation">
          <div className="flex">
            {this.getNavigate(this.props.navigateList[folder.id].parent, true, !enabledClick)}
            {this.renderNavigate(folder, title, enabledClick, isLastNavigate)}
          </div>
          <div className="navigate-menu">
            {this.renderNavigate(folder, title, enabledClick)}
            {this.state.showMenuNavigate ? (
              <div className="wrraped-navigate-menu" >
                {this.getNavigate(
                  this.props.navigateList[folder.id].parent,
                  true
                )}
              </div>
            ) : null}
          </div>
        </div>
      );
    } else {
      let title = this.props.navigateList[folder.id].title;
      return <div>{this.renderNavigate(folder, title, enabledClick, isLastNavigate)}</div>;
    }
  }

  render() {
    return (
      <div className= "wrapperMenu">
      <div className= "menu">
      {/* NAVIGATION//////////////// */}
        <div
          className={
             this.state.showSearchMobile
              ? "hide-wrapperNavigation"
              : "wrapperNavigation"
          }
        >
          <div
            className={
            this.state.SearchSignleFile || this.state.showSearchMobile ?
            "hide-navigate-icon":
            "navigate-icon"
            }
            onClick={this.showMenuNavigate.bind(this)}
            ref={node => {
              this.node = node;
            }}
          >
         {
          //  {/* {Wix.Utils.getWidth()==320 ? */}
             this.state.SearchSignleFile || this.state.showSearchMobile ?
               <div className="hide-navigate-icon"/>
             :
             this.props.navigateList && this.props.navigateList[this.props.driveSelected.id] && this.props.navigateList[this.props.driveSelected.id].parent.id ?
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
                <g  fill="none" fillRule="evenodd" className="fill-stroke navigate-icon" >
                    <path d="M1.415 17.19V1.687a1 1 0 0 1 1.002-1l6.96.02a1 1 0 0 1 .786.385l1.954 2.501a1 1 0 0 0 .788.384h8.679a1 1 0 0 1 1 1V17.19H1.414zM1.38 3.982h11.478"/>
                    <path d="M14.414 9.658l-2.769 2.838-2.77-2.838"/>
                </g>
              </svg> :
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
                <g fill="none" fillRule="evenodd" stroke="#000">
                    <path  className="fill-stroke"  d="M1.415 17.19V1.687a1 1 0 0 1 1.002-1l6.96.02a1 1 0 0 1 .786.385l1.954 2.501a1 1 0 0 0 .788.384h8.679a1 1 0 0 1 1 1V17.19H1.414zM1.38 3.982h11.478"/>
                </g>
            </svg>
            }
          </div>
          {
            this.state.SearchSignleFile? (
            <div className="search-result flex">
              <div
                onClick={() => {
                  this.props.openFolder(this.props.driveSelected);
                  this.searchInput.value = '';
                  this.setState({ showSearchMobile: false, searchInput: ''});
                }}
              >
                <span className="navigateArrowSearchResult">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 5 9"><defs></defs><title>Arrow left</title><g fillRule="evenodd" id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Mask"><polygon className="cls-1 fill" points="5 0.5 1 4.5 5 8.5 4.5 9 0 4.5 4.5 0 5 0.5"/></g></g></g></svg>
               </span>
              </div>

              <div >{this.state.deviceType=== "mobile" ? this.state.resultLength +  " Result" :this.state.resultLength + " " + this.props.intl.formatMessage({id: 'widget.resultFound'})} </div>
            </div>
          ) : this.props.driveSelected &&
          this.props.driveSelected.mimeType === parameters["TYPE_FOLDER"] &&
          !this.state.showSearchMobile ? (
            this.getNavigate(this.props.driveSelected, false)
          ) : null}
        </div>
      {/* END-NAVIGATION//////////////// */}

      <div className="wrapperSearchAndIcons">
      {/* ICON AND INPUT IN SEARCH ************ */}
          <div  className={!this.state.showSearchMobile ? "hideIconInput" : "showIconInput"}>
            <div className="searchIconMobile" onClick={this.searchMobileClicked}>
              {
                this.state.displaySearchBar && this.state.showSearchMobile
                  ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                     <path className="fill"  d="M9.905 9l3.031 3.072a.2.2 0 0 1 0 .281l-.623.632a.2.2 0 0 1-.285 0L9 9.917 9.905 9zM5.5 11a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0-1a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z"/>
                  </svg>
                  :
                  <div className="hideSearchIconMobile"/>
              }

            </div>
            <div
              className={
                this.state.showSearchMobile
                  ? "wrapperSearchInput"
                  : "hide-wrapperSearchInput"
              }
            >
              <input
                className={
                  this.state.displaySearchBar
                    ? "textInputSearch"
                    : "hideTextInputSearch"
                }
                type="text"
                placeholder={this.props.intl.formatMessage({id: 'widget.search'})}
                ref={node => (this.searchInput = node)}
                onKeyPress={event => {
                  if (event.key === "Enter") {
                    this.searchFile();
                  }
                }}
              />
            </div>
          </div>
      {/* ************************** */}
      {/* MENU ICONS &&&&&&&&&&&&&&&&&&&&&&&&&& */}
          {
            <div
              className={
               this.state.showMenuIcons? "menuIcons" : "hide-menuIcons"
              }
            >
              {this.state.displaySearchBar && this.state.deviceType ==="mobile" ? (
              <div className = "mobileSearch" onClick={this.showSearchMobileClicked}>
                 <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                  <path className="fill"  d="M9.905 9l3.031 3.072a.2.2 0 0 1 0 .281l-.623.632a.2.2 0 0 1-.285 0L9 9.917 9.905 9zM5.5 11a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0-1a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z"/>
                 </svg>
              </div>
              ) : (
                <div className="searchIcon" />
              )}
              {this.state.displaySearchBar ? (
                <div
                  className="searchIcon displaySearchIcon"
                  onClick={this.searchFile}
                >
                 <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                  <path className="fill"  d="M9.905 9l3.031 3.072a.2.2 0 0 1 0 .281l-.623.632a.2.2 0 0 1-.285 0L9 9.917 9.905 9zM5.5 11a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0-1a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z"/>
                </svg>
                </div>
              ) : (
                <div className="searchIcon" />
              )}
            </div>
          }
          {/* &&&&&&&&&&&&&&&&&&&&&&&&&&&&& */}

        </div>
      {/*CLOSE SEARCH BUTTON xxxxxxxxxxxxxxxxxxxxxxxxx */}
        {this.state.showSearchMobile && !this.state.showMenuIcons ? (
          <div className="close-search-mobile"  onClick={this.closeSearchMobile}>
            <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                <g   id="Desktop-Flow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g className="fill" id="Docs-instructions" transform="translate(-323.000000, -2358.000000)">
                        <g id="Group-9" transform="translate(323.000000, 2358.000000)">
                            <g id="Icons-/-Close">
                                <path d="M6,5.07692308 L11.0769231,1.15463195e-14 L12,0.923076923 L6.92307692,6 L12,11.0769231 L11.0769231,12 L6,6.92307692 L0.923076923,12 L-2.30926389e-14,11.0769231 L5.07692308,6 L-2.30926389e-14,0.923076923 L0.923076923,1.17683641e-14 L6,5.07692308 Z" id="Mobile-Icons-Close"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
          </div>
        ) : (
          <div className="hide-close-search-mobile" />
        )}
      {/* xxxxxxxxxxxxxxxxxxxxxxx */}

      </div>
       {this.state.layoutFolder === 2 && this.state.deviceType === "mobile" ?
         null : <hr className="divider-top"/> }
      </div>
    );
  }



}
const mapStateToProps = state => ({
  navigateList: state.widgetReducer.navigationList,
  navigationListSearch: state.widgetReducer.navigationListSearch
});
const mapDispatchToProps = dispatch => ({
  updateNavigationList: navigateList =>
    dispatch(updateNavigationList(navigateList)),
  updateNavigationListSearch: navigationListSearch =>
  dispatch(updateNavigationListSearch(navigationListSearch))
});


export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(Menu));



// WEBPACK FOOTER //
// ./src/widget/components/menu/Menu.js